'use strict';

//Teams service used to communicate Teams REST endpoints
angular.module('teams').factory('TranslationMemory', ['$resource',
	function($resource) {
		return $resource('v1/teams/:teamId/translation-memory', {
			groupId: '@groupId',
			mobileAppId: '@mobileAppId',
			teamId: '@teamId'
		}, {
			add: {
				method: 'POST',
				url : 'v1/teams/:teamId/translation-memory/add/:mobileAppId'
			},
			autotranslate: {
				method: 'POST',
				url : 'v1/teams/:teamId/translation-memory/autotranslate/:mobileAppId/:groupId'
			},
			create: {
				method: 'POST',
				url : 'v1/teams/:teamId/translation-memory/create'
			}
		});
	}
]);
